import { v4 as uuid } from 'uuid';
import get from 'lodash/get';
import {
    createBuildingBlocksFromTemplate,
    subtitleGenerator,
    titleGenerator,
    stepTextContentGenerator,
    secondaryButtonWithPreviousActionGenerator,
    primaryButtonGenerator,
} from '../utils/ai-template-utils';
import { AiBlocks } from '@pendo/services/BuildingBlocks';
import { AI_LAYOUT_TEXT } from '../utils/constants';
import { BuildingBlockLayouts } from '@pendo/services/BuildingBlocks';
import { createLightboxStepTemplate, createFirstArtifactStep } from './steps-template';

const { PrebuiltLayouts } = BuildingBlockLayouts;

export const WALKTHROUGH_STEP_TEMPLATE = {
    SECOND_STEP: {
        ARTIFACT_KEYS_TO_GENERATORS: {
            subtitle: subtitleGenerator,
            title: titleGenerator,
            stepTextContent: stepTextContentGenerator,
            buttons: {
                secondaryButton: secondaryButtonWithPreviousActionGenerator,
                primaryButton: primaryButtonGenerator,
            },
        },
    },
    THIRD_STEP: {
        ARTIFACT_KEYS_TO_GENERATORS: {
            title: titleGenerator,
            stepTextContent: stepTextContentGenerator,
            buttons: {
                primaryButton: primaryButtonGenerator,
            },
        },
    },
};

export function createArtifactStepsFromWalkthroughTemplate () {
    return [
        createFirstArtifactStep(),
        {
            primaryButton: AI_LAYOUT_TEXT.NEXT,
            secondaryButton: AI_LAYOUT_TEXT.BACK,
            stepTextContent: AI_LAYOUT_TEXT.BODY,
            subtitle: AI_LAYOUT_TEXT.STEP_X_OF_Y,
            title: AI_LAYOUT_TEXT.TITLE,
        },
        {
            primaryButton: AI_LAYOUT_TEXT.PRIMARY_CTA,
            stepTextContent: AI_LAYOUT_TEXT.BODY,
            title: AI_LAYOUT_TEXT.TITLE,
        },
    ];
}

export function createGeneratedWalkthroughTemplate ({ theme, generatedSteps, steps }) {
    const stepCreatorsMap = {
        0: createFirstStepWalkthroughTemplate,
        [generatedSteps.length - 1]: createThirdStepWalkthroughTemplate,
    };

    const newSteps = generatedSteps.map((step, index) => {
        const stepCreator = stepCreatorsMap[index] || createSecondStepWalkthroughTemplate;
        const stepBlocks = stepCreator({
            theme,
            stepArtifact: step,
            stepBlocks: get(steps, `[${index}].buildingBlocks`),
        });

        return stepBlocks;
    });

    return AiBlocks.prepStepsForPreview(newSteps, steps, theme);
}

function createFirstStepWalkthroughTemplate ({ theme, stepArtifact, stepBlocks }) {
    return createLightboxStepTemplate({ theme, width: 471, stepArtifact, stepBlocks });
}

function createSecondStepWalkthroughTemplate ({ theme, stepArtifact = {}, stepBlocks }) {
    const buildingBlocks = stepBlocks || PrebuiltLayouts.TooltipLayouts.createTooltipBlank(uuid(), theme);

    return createBuildingBlocksFromTemplate({
        theme,
        width: 471,
        isEmbeddedGuide: false,
        buildingBlocks,
        stepArtifact,
        artifactKeysToGenerators: WALKTHROUGH_STEP_TEMPLATE.SECOND_STEP.ARTIFACT_KEYS_TO_GENERATORS,
    });
}

function createThirdStepWalkthroughTemplate ({ theme, stepArtifact, stepBlocks }) {
    return createLightboxStepTemplate({
        theme,
        width: 471,
        stepBlocks,
        stepArtifact,
        generators: WALKTHROUGH_STEP_TEMPLATE.THIRD_STEP.ARTIFACT_KEYS_TO_GENERATORS,
    });
}
